import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractControl, FormArray, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { Observable } from 'rxjs/Observable';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { CandidatoService } from '../../candidato/candidato.service';

@Component({
  templateUrl: './cadastrar-resultado-exame-toxicologico.component.html',
})
export class CadastrarResultadoExameToxicologicoComponent extends WebPage implements OnInit {

  uploadUrl: string;
  candidato;
  arquivosToRemove = new FormArray([]);

  get idCandidato() { return this.form.get('idCandidato'); }
  get arquivos() { return this.form.get('arquivos') as FormArray; }

  form: FormGroup;
  constructor(
    private fb: FormBuilder,
    private confirmationService: ConfirmationService, messageService: MessageService,
    private route: ActivatedRoute, private router: Router,
    private candidatoService: CandidatoService, private arquivoService: ArquivoService
  ) {
    super(messageService);

    this.route.paramMap.subscribe(params => {
      this.form = this.fb.group({
        idCandidato: [params.get('idCandidato')],
        arquivos: new FormArray([]),
        resultado: [null, Validators.required],
        observacao: [null, Validators.required],
      });
    });

    this.uploadUrl = this.arquivoService.uploadUrl + 'resultadoExameToxicologico';
  }

  ngOnInit() {
    this.isLoading = true;
    this.candidatoService.getFull(this.idCandidato.value)
      .finally(() => this.isLoading = false)
      .subscribe(
        candidato => this.candidato = candidato,
        error => this.gerenciaErro(error)
      );
  }

    // ------
  // Arquivos
  adicionaArquivo(idArquivo, nomeArquivo, isOld: boolean) {
    this.isLoading = false;

    const arquivoFormGroup = this.fb.group({
      idArquivo: idArquivo,
      nomeArquivo: nomeArquivo,
      isOld: isOld
    });
    this.arquivos.push(arquivoFormGroup);
  }

  removeArquivo(arquivo: AbstractControl) {
    this.arquivosToRemove.push(arquivo);

    const index = this.arquivos.controls.indexOf(arquivo);
    this.arquivos.removeAt(index);
  }

  removeArquivosDoBanco(arquivos: AbstractControl[]) {
    this.isLoading = true;
    const combined = arquivos.map(a => this.arquivoService.removeArquivo(a.value.idArquivo));
    Observable.combineLatest(combined)
      .finally(() => this.isLoading = false)
      .subscribe(
        () => {},
        error => this.gerenciaErro(error)
      );
  }

  uploadError(mensagem) {
    this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: mensagem });
    this.isLoading = false;
  }
  // Arquivo
  // ------

  cadastrarExameToxicologico() {
    if (!this.validaForm()) {
      return;
    }

    this.confirmationService.confirm({
      message: 'Deseja salvar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.removeArquivosDoBanco(this.arquivosToRemove.controls);

        this.isLoading = true;
        this.candidatoService.salvarResultadoExameToxicologico(this.form.value)
          .finally(() => this.isLoading = false)
          .subscribe(
            () => this.router.navigate(['/gerenciar-etapas/']),
            error => this.gerenciaErro(error)
          );
      },
      reject: () => {
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  validaForm(): boolean {
    if (this.arquivos.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Documento não inserido!' });
      return false;
    }

    if (this.arquivos.length !== 1) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'É necessário carregar apenas 1 arquivo!' });
      return false;
    }

    if (this.form.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Campo obrigatório não preenchido!' });
      return false;
    }

    return true;
  }

  cancelar() {
    this.confirmationService.confirm({
      message: 'Deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        const arquivosNovos = this.arquivos.controls.filter(arquivo => !arquivo.value.isOld);
        arquivosNovos.concat(this.arquivosToRemove.controls.filter(arquivo => !arquivo.value.isOld));
        this.removeArquivosDoBanco(arquivosNovos);

        this.router.navigate(['/gerenciar-exame-toxicologico/' + this.idCandidato.value]);
      }
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/components/exameToxicologico/cadastrar-resultado-exame-toxicologico/cadastrar-resultado-exame-toxicologico.component.ts